var _ = require("../uam/fields.module.js")(module.exports, {
    namespace: "attr.default",
    title: "Default Value",
    description: "Applies a default value if the current value is null or undefined.",
    type: "attribute",
    use: {
        followType: true// <- this allows the module to follow the type of the field it is applied to
    },
    altersValue: true, // <- this helps validation manager know this module can mutate the value
    tests: {
        applyDefault: {
            must: true,
            run: function () {
                return validate({ title: "Status", default: "active" }, undefined);
            }
        },
        noDefault: {
            must: true,
            run: function () {
                return validate({ title: "Status" }, "live");
            }
        }
    },
    errors: {}
});

function validate(spec, value) {
    if ((value === null || value === undefined) && "default" in spec) {
        return spec.default;
    }

    return value;
}
module.exports.validate = validate;
